module.exports = __webpack_public_path__ + "img/frame-3.62b2fac0.svg";